import { Tabs } from 'antd';
import React, { useState } from 'react';
import Title from 'antd/es/typography/Title';

import PricingTable from './Components/PricingTable';
import PricingTaxiTable from './TaxiZoneTime/TaxiZoneTimePricingTable';
import BasicTaxiDistancePricingTable from './TaxiBasic/BasicTaxiDistancePricingTable';

import { PricingInfoProvider } from './hooks/useCurrentPricing';
import { BasicPricingInfoProvider } from './TaxiBasic/hooks/useCurrentBasicPricingTaxi';
import { PricingTaxiInfoProvider } from './TaxiZoneTime/useCurrentZoneTimePricingTaxi';
import { CarOutlined, EnvironmentOutlined, ThunderboltOutlined } from '@ant-design/icons';

const PricingView = () => {
    const [currentTab] = useState('0');

    const items = [
        {
            label: (
                <span>
                    <CarOutlined />
                    Taxi-Mobility Basic
                </span>
            ),
            children: (
                <BasicPricingInfoProvider>
                    <BasicTaxiDistancePricingTable />
                </BasicPricingInfoProvider>
            ),
            key: '0',
            disabled: false,
        },
        {
            label: (
                <span>
                    <EnvironmentOutlined />
                    Taxi-Mobility Zone & time
                </span>
            ),
            children: (
                <PricingTaxiInfoProvider>
                    <PricingTaxiTable />
                </PricingTaxiInfoProvider>
            ),
            key: '1',
            disabled: false,
        },
        {
            label: (
                <span>
                    <ThunderboltOutlined />
                    Micro-Mobility
                </span>
            ),
            children: (
                <PricingInfoProvider>
                    <PricingTable />
                </PricingInfoProvider>
            ),
            key: '2',
            disabled: false,
        },
    ];

    return (
        <>
            <Title level={3}>Ride Pricing</Title>
            <Tabs defaultActiveKey={currentTab} items={items} />
        </>
    );
};

export default PricingView;
